
<template>
  <!--产品分类-->
<category></category>
</template>

<script>
import category from '@/components/package/category.vue';
export default {
  components: {
    category
  },
  name: 'productCate',
  data () {
    return {};
  },
  mounted () {
  },
  methods: {
  }
};
</script>
